import { FC } from "react";

interface BusIconProps {
  className?: string;
}

const BusIcon: FC<BusIconProps> = ({ className }) => {
  return (
    <div className={className}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="path-1-outside-1_14626_75810"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
          fill="black"
        >
          <rect fill="white" width="16" height="16" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.7 1C2.59543 1 1.7 1.89543 1.7 3V4.5C1.3134 4.5 1 4.8134 1 5.2V8C1 8.3866 1.3134 8.7 1.7 8.7V12.9V13.6C1.7 14.3732 2.3268 15 3.1 15C3.8732 15 4.5 14.3732 4.5 13.6L11.5 13.6C11.5 14.3732 12.1268 15 12.9 15C13.6732 15 14.3 14.3732 14.3 13.6L14.3 12.9V8.7C14.6866 8.7 15 8.3866 15 8V5.2C15 4.8134 14.6866 4.5 14.3 4.5L14.3 3C14.3 1.89543 13.4046 1 12.3 1H3.7Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.7 1C2.59543 1 1.7 1.89543 1.7 3V4.5C1.3134 4.5 1 4.8134 1 5.2V8C1 8.3866 1.3134 8.7 1.7 8.7V12.9V13.6C1.7 14.3732 2.3268 15 3.1 15C3.8732 15 4.5 14.3732 4.5 13.6L11.5 13.6C11.5 14.3732 12.1268 15 12.9 15C13.6732 15 14.3 14.3732 14.3 13.6L14.3 12.9V8.7C14.6866 8.7 15 8.3866 15 8V5.2C15 4.8134 14.6866 4.5 14.3 4.5L14.3 3C14.3 1.89543 13.4046 1 12.3 1H3.7Z"
          fill="white"
        />
        <path
          d="M1.7 4.5V5.5H2.7V4.5H1.7ZM1.7 8.7H2.7V7.7H1.7V8.7ZM4.5 13.6L4.5 12.6H3.5V13.6H4.5ZM11.5 13.6H12.5V12.6H11.5V13.6ZM14.3 13.6L15.3 13.6V13.6L14.3 13.6ZM14.3 12.9H13.3V12.9L14.3 12.9ZM14.3 8.7V7.7H13.3V8.7H14.3ZM14.3 4.5L13.3 4.5L13.3 5.5H14.3V4.5ZM14.3 3L15.3 3V3H14.3ZM2.7 3C2.7 2.44771 3.14771 2 3.7 2V0C2.04315 0 0.7 1.34314 0.7 3H2.7ZM2.7 4.5V3H0.7V4.5H2.7ZM2 5.2C2 5.36568 1.86569 5.5 1.7 5.5V3.5C0.761115 3.5 0 4.26112 0 5.2H2ZM2 8V5.2H0V8H2ZM1.7 7.7C1.86569 7.7 2 7.83431 2 8H0C0 8.93888 0.761115 9.7 1.7 9.7V7.7ZM2.7 12.9V8.7H0.7V12.9H2.7ZM0.7 12.9V13.6H2.7V12.9H0.7ZM0.7 13.6C0.7 14.9255 1.77452 16 3.1 16V14C2.87909 14 2.7 13.8209 2.7 13.6H0.7ZM3.1 16C4.42548 16 5.5 14.9255 5.5 13.6H3.5C3.5 13.8209 3.32091 14 3.1 14V16ZM11.5 12.6L4.5 12.6L4.5 14.6L11.5 14.6V12.6ZM10.5 13.6C10.5 14.9255 11.5745 16 12.9 16V14C12.6791 14 12.5 13.8209 12.5 13.6H10.5ZM12.9 16C14.2255 16 15.3 14.9255 15.3 13.6L13.3 13.6C13.3 13.8209 13.1209 14 12.9 14V16ZM13.3 12.9L13.3 13.6L15.3 13.6L15.3 12.9L13.3 12.9ZM13.3 8.7V12.9H15.3V8.7H13.3ZM14 8C14 7.83432 14.1343 7.7 14.3 7.7V9.7C15.2389 9.7 16 8.93888 16 8H14ZM14 5.2V8H16V5.2H14ZM14.3 5.5C14.1343 5.5 14 5.36568 14 5.2H16C16 4.26112 15.2389 3.5 14.3 3.5V5.5ZM13.3 3L13.3 4.5L15.3 4.5L15.3 3L13.3 3ZM12.3 2C12.8523 2 13.3 2.44772 13.3 3H15.3C15.3 1.34315 13.9569 0 12.3 0V2ZM3.7 2H12.3V0H3.7V2Z"
          fill="#127EF1"
          mask="url(#path-1-outside-1_14626_75810)"
        />
        <path
          d="M1.69922 12.9004H4.49922V13.6004C4.49922 14.3736 3.87242 15.0004 3.09922 15.0004C2.32602 15.0004 1.69922 14.3736 1.69922 13.6004V12.9004Z"
          fill="#161616"
        />
        <path
          d="M11.5 12.9004H14.3V13.6004C14.3 14.3736 13.6732 15.0004 12.9 15.0004C12.1268 15.0004 11.5 14.3736 11.5 13.6004V12.9004Z"
          fill="#161616"
        />
        <rect
          x="1.69922"
          y="10.7998"
          width="12.6"
          height="1.4"
          fill="#FFD82E"
        />
        <rect
          x="1.69922"
          y="12.2002"
          width="12.6"
          height="1.4"
          fill="#127EF1"
        />
        <path
          d="M2.39844 4.5H13.5984V7.1C13.5984 8.75686 12.2553 10.1 10.5984 10.1H5.39843C3.74158 10.1 2.39844 8.75685 2.39844 7.1V4.5Z"
          fill="#767676"
        />
        <path
          d="M3.45078 11.5C3.64408 11.5 3.80078 11.6567 3.80078 11.85C3.80078 12.0433 3.64408 12.2 3.45078 12.2H1.70078V11.5H3.45078Z"
          fill="#CACACA"
        />
        <path
          d="M14.3008 11.5V12.2H12.5508C12.3575 12.2 12.2008 12.0433 12.2008 11.85C12.2008 11.6567 12.3575 11.5 12.5508 11.5H14.3008Z"
          fill="#CACACA"
        />
        <rect
          x="9.75"
          y="2.75"
          width="3.5"
          height="0.7"
          rx="0.35"
          transform="rotate(90 9.75 2.75)"
          fill="#CACACA"
        />
      </svg>
    </div>
  );
};

export default BusIcon;
